// extracted by mini-css-extract-plugin
module.exports = {"loadingSection":"LoadingSection-module__loadingSection___arWlw"};